export function addTimestampToFilename(filename: string) {
  const lastIndex = filename.lastIndexOf('.');
  const timestamp = new Date().getTime();
  return lastIndex >= 0
    ? `${filename.substring(0, lastIndex)}_${timestamp}${filename.substring(
        lastIndex
      )}`
    : `${filename}_${timestamp}`;
}
